export const CREATE_INVESTOR_DECK_ATTEMPT = 'CREATE_INVESTOR_DECK_ATTEMPT';
export type CREATE_INVESTOR_DECK_ATTEMPT = typeof CREATE_INVESTOR_DECK_ATTEMPT;

export const CREATE_INVESTOR_DECK_SUCCESS = 'CREATE_INVESTOR_DECK_SUCCESS';
export type CREATE_INVESTOR_DECK_SUCCESS = typeof CREATE_INVESTOR_DECK_SUCCESS;

export const CREATE_INVESTOR_DECK_FAILURE = 'CREATE_INVESTOR_DECK_FAILURE';
export type CREATE_INVESTOR_DECK_FAILURE = typeof CREATE_INVESTOR_DECK_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/investor-deck/create/Types.tsx